module.exports = {"name":"GSM Trackers","menu_entries":{"gsmTrackers":"GSM Trackers"}}